/* Copyright (c) 2026 Xperi. All Rights Reserved. */

// Auth-scheme resolution moved to the model layer alongside TokenManager, so
// the token refresh strategy can reach it without the model depending on the
// view-model. Re-exported here because the sign-in thunks are its other
// consumer and read it through this barrel.
export type { TAuthorizationSchemes } from "../../../model/auth";
export {
  DEFAULT_AUTH_SCHEMES,
  findAuthorizationSchemes,
  findIpAutoLoginAuthenticationUrl,
  resolveAuthorizationSchemes,
  resolveDbsSchemes,
  resolveDomainTokenScheme,
  resolveIpAutoLoginAuthenticationUrl
} from "../../../model/auth";
export {
  classifyIpAutoLoginError,
  classifyIpJwtError,
  extractHttpStatus,
  extractSignInErrorCode,
  SIGN_IN_FALLBACK_ERROR_CODE,
  toIpAutoLoginError,
  toSignInErrorPayload
} from "./authErrors";
export {
  classifyAuthType,
  isDomainTokenExpired,
  isIpAutoLoginFeatureEnabled,
  isIpAutoLoginInFlight,
  persistProvisionData
} from "./authHelpers";
export type {
  TAlertDispatch,
  TCriticalRetryOverlayOptions
} from "./retryOverlay";
export {
  createCriticalRetryOptions,
  isDefinitiveSignInFailure
} from "./retryOverlay";
export {
  createSilentRetryOptions,
  SILENT_MAX_RETRY_AFTER_MS,
  SILENT_RETRY_DELAYS_MS
} from "./silentRetry";
export {
  DLID_PERMANENTLY_REMOVED_SERVICE_CODE,
  isDeviceIdentityRemovedError,
  recoverRemovedDeviceIdentity,
  recoverRemovedDeviceIdentityAfterSignIn
} from "./deviceIdentityRecovery";
export {
  beginDbsPollingSession,
  scheduleNextDbsPoll,
  stopDbsPolling
} from "./dbsPollingController";
export {
  beginSignInSession,
  cancelSignInSession,
  endSignInSession
} from "./signInSessionController";
export type { TBeginSignInAttempt } from "./signInTelemetry";
export {
  beginSignInAttempt,
  cancelSignInAttempt,
  completeSignInAttempt,
  endSignInAttempt,
  failSignInAttempt,
  isSignInAttemptOpen,
  markAttemptedType,
  markStep,
  markStepReached,
  resetSignInTelemetryForTest
} from "./signInTelemetry";
